import {createAsyncAction, createStandardAction} from "typesafe-actions";
import {ISettingsState} from "./types";

export const changeSettings = createStandardAction('@settings/CHANGE_SETTINGS')<Partial<ISettingsState>>();

export const loadTheme = createAsyncAction(
    '@settings/LOAD_THEME_REQUEST',
    '@settings/LOAD_THEME_SUCCESS',
    '@settings/LOAD_THEME_FAILURE')<string, void, string>();